import React from 'react';
import './isi.scss';
import IsiButton from './IsiButton';

function IsiSticky({ isOpen, setIsOpen, stickyRef }) {
  return (
    <section className="isi isi--sticky" ref={stickyRef}>
      <div className={isOpen ? 'isi__wrapper  isi__wrapper--open' : 'isi__wrapper'}>
        <IsiButton isOpen={isOpen} setIsOpen={setIsOpen} origin={'sticky'} />
        <section className={`isi__body isi__body-${origin}`}>
          <h4 className="isi__body__bold">INDICATIONS</h4>
          <div className="isi__body__paragraph isi__body__paragraph--nogap">
            <h6 className="isi__body__bold">What is SPRAVATO® (esketamine) CIII nasal spray?</h6>
            <p className="isi__body__text">
              SPRAVATO® is a prescription medicine, used along with an antidepressant taken by mouth
              to treat:{' '}
            </p>
            <ul className="isi__body__ul isi__body__ul--top">
              <li className="isi__body__text">Adults with treatment-resistant depression (TRD)</li>
              <li className="isi__body__text">
                Depressive symptoms in adults with major depressive disorder (MDD) with suicidal
                thoughts or actions
              </li>
            </ul>
          </div>
        </section>
      </div>
    </section>
  );
}

export default IsiSticky;
